/*
 * "Sign in for wiring" (snippets/excel-wire-trade-button.liquid) opens a small menu with Sign in and Sign up
 * (the trade account application). One menu sits on <body> and is placed under the clicked button, so card
 * overflow, table grids and transforms never clip it. Loaded for signed-out visitors only; without it the
 * button is a plain Sign in link. Modified clicks (new tab or window) still follow that link. The menu takes the
 * clicked button's colour and corner radius, so it matches the button on each page.
 */
(() => {
  let menu = null;
  let trigger = null;

  const build = () => {
    menu = document.createElement('div');
    menu.className = 'excel-wire-trade-menu';
    menu.id = 'ExcelWireTradeMenu';
    menu.hidden = true;
    menu.innerHTML = '<a class="excel-wire-trade-menu__link excel-wire-trade-menu__link--primary" data-sign-in></a><a class="excel-wire-trade-menu__link" data-sign-up></a>';
    // Tabbing out of the menu closes it; going back to its button doesn't.
    menu.addEventListener('focusout', event => {
      if (trigger && !menu.contains(event.relatedTarget) && event.relatedTarget !== trigger) close();
    });
    document.body.append(menu);
  };

  // Under the button (above it when there's no room below), at least as wide as the button.
  const place = () => {
    const box = trigger.getBoundingClientRect();
    const width = Math.min(Math.max(box.width, 232), window.innerWidth - 16);
    menu.style.width = `${width}px`;
    menu.style.left = `${Math.min(Math.max(8, box.left + (box.width - width) / 2), window.innerWidth - width - 8)}px`;
    const height = menu.offsetHeight;
    const below = box.bottom + 8 + height <= window.innerHeight || box.top < height + 16;
    menu.style.top = `${below ? box.bottom + 8 : box.top - 8 - height}px`;
  };

  const close = (returnFocus = false) => {
    if (!trigger) return;
    const button = trigger;
    trigger = null;
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    if (returnFocus) button.focus();
  };

  const open = (button, keyboard) => {
    if (!menu) build();
    trigger = button;
    const signIn = menu.querySelector('[data-sign-in]');
    const signUp = menu.querySelector('[data-sign-up]');
    signIn.href = button.getAttribute('href');
    signIn.textContent = button.dataset.signInLabel;
    signUp.href = button.dataset.signUpUrl;
    signUp.textContent = button.dataset.signUpLabel;
    // Take the button's colour (its fill, or its text on outlined buttons such as Quick Shop's) and corner radius,
    // read from an unhovered copy so a hover shade doesn't stick to the menu.
    const probe = button.cloneNode(false);
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;transition:none';
    button.after(probe);
    const look = getComputedStyle(probe);
    const filled = !/^(transparent|rgba\(.*,\s*0\))$/.test(look.backgroundColor);
    menu.style.setProperty('--excel-wire-trade-accent', filled ? look.backgroundColor : look.color);
    menu.style.setProperty('--excel-wire-trade-radius', look.borderTopLeftRadius);
    probe.remove();
    button.setAttribute('aria-controls', menu.id);
    button.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    place();
    if (keyboard) signIn.focus();
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wire-trade-menu]');
    if (button) {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const reopen = button !== trigger;
      close();
      if (reopen) open(button, event.detail === 0);
      return;
    }
    if (trigger && !menu.contains(event.target)) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && trigger) close(true);
  });
  window.addEventListener('resize', () => close());
  window.addEventListener('scroll', () => { if (trigger) place(); }, { passive: true, capture: true });
})();
